import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component
export default class Loading extends Vue {
  @Prop({ default: 'white' })
  color: string

  @Prop({ default: 0.2 })
  width: number
}
